import { uploadDrn } from "../endpoints";
import axios from "axios";
export const uploadDRNpdf = async (formData: any) => {
  const idToken =
    "eyJ0eXAiOiJKV1QiLCJub25jZSI6IkpKcTM2U3NXYTFPOEJSUGhmbC1rNGdFS2tVTE02UDAxZTlRNWxXS19Vd1EiLCJhbGciOiJSUzI1NiIsIng1dCI6IjlHbW55RlBraGMzaE91UjIybXZTdmduTG83WSIsImtpZCI6IjlHbW55RlBraGMzaE91UjIybXZTdmduTG83WSJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC9lYTgwOTUyZS1hNDc2LTQyZDQtYWFmNC01NDU3ODUyYjBmN2UvIiwiaWF0IjoxNzAwNTUxMTUwLCJuYmYiOjE3MDA1NTExNTAsImV4cCI6MTcwMDU1NjE3OSwiYWNjdCI6MCwiYWNyIjoiMSIsImFjcnMiOlsidXJuOnVzZXI6cmVnaXN0ZXJzZWN1cml0eWluZm8iLCJjMjUiXSwiYWlvIjoiQVZRQXEvOFZBQUFBQ0ZpVVdhUW96a1B2MDBaR2VXYzZvL2N1ZHg3NjhCYlZHN0NldjhQeVU0NFNFcVJ2a01LV3hxODc0THBrRXdFdE1LZ0JPT2g3WldRM1dycUMxUTF0NG1XWVVvSUdiNjJUSXpoSnQzU29RaGM9IiwiYW1yIjpbInB3ZCIsInJzYSIsIm1mYSJdLCJhcHBfZGlzcGxheW5hbWUiOiJ0ZXN0aW5nIHJlYWN0IGFwcCAiLCJhcHBpZCI6IjVmMTdiMmU5LWM5NzYtNDBmMi04MTgxLThhODUyMTgyYTFiNiIsImFwcGlkYWNyIjoiMCIsImRldmljZWlkIjoiODU5NjgxMmEtM2M1MC00YmUyLTgzYTgtZmRiMDFiNzM2ZWQ2IiwiZmFtaWx5X25hbWUiOiJHb3NhYmFsIiwiZ2l2ZW5fbmFtZSI6IkpkbmFuZXNoIiwiaWR0eXAiOiJ1c2VyIiwiaXBhZGRyIjoiMTM2LjIyNi4yNDQuMTg5IiwibmFtZSI6Ikdvc2FiYWwsIEpkbmFuZXNoIChXSVBSTyBURUNITk9MT0dJRVMpIiwib2lkIjoiZmI0ZDNhMDItMTdmYi00ZTk1LTgzOGQtYzdkN2RmNzJmMDJjIiwib25wcmVtX3NpZCI6IlMtMS01LTIxLTE4MDE2NzQ1MzEtNTE1OTY3ODk5LTgzOTUyMjExNS0xODg2MDU0NiIsInBsYXRmIjoiMyIsInB1aWQiOiIxMDAzMjAwMUQ5RjcwNzJGIiwicmgiOiIwLkFRa0FMcFdBNm5hazFFS3E5RlJYaFNzUGZnTUFBQUFBQUFBQXdBQUFBQUFBQUFBSkFOOC4iLCJzY3AiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCIsInNpZ25pbl9zdGF0ZSI6WyJrbXNpIl0sInN1YiI6InVLOF8yMFlZS05vYnlFbVRLeExyMEhNdnhvc2JmMGRiVWdTWnNMVFdFRFkiLCJ0ZW5hbnRfcmVnaW9uX3Njb3BlIjoiRVUiLCJ0aWQiOiJlYTgwOTUyZS1hNDc2LTQyZDQtYWFmNC01NDU3ODUyYjBmN2UiLCJ1bmlxdWVfbmFtZSI6ImpkbmFuZXNoLmdvc2FiYWxAYnAuY29tIiwidXBuIjoiamRuYW5lc2guZ29zYWJhbEBicC5jb20iLCJ1dGkiOiJLckpWWlRFMmQwQ2xqd3RwWFZHdkFBIiwidmVyIjoiMS4wIiwid2lkcyI6WyJiNzlmYmY0ZC0zZWY5LTQ2ODktODE0My03NmIxOTRlODU1MDkiXSwieG1zX3N0Ijp7InN1YiI6Ii1fTjBhbDU3OUI2UmM2d3FHNUVHSVdiM0s1LXUtV2xEV1pYTGNQaHFaQmcifSwieG1zX3RjZHQiOjE0MDI5OTMxODd9.bYESBAap1_7a2MAoG_B1PQnVbvfT2EcCgO3eP2ab_tEdkVNSQeoy3C2n1w2taWHAXvjpjsKknpV4WCutX7ynAoCh1g7iw42Ivo4eqVPSdbtBM_m7w-lzLhd6TPJc35tgUcJcNv1dZcbJPqxog6_C5hipX5VN8LaszP5sYxU4tedBVUMPBQgc_vU91OLk9BW6TJ2NBXawlljCMnJbzBRDMzKFJ0i2l7LCA7tcj7ON0Ak1WUjBp_tJN73CUJn8pHUxLn9nyW08QGyiJwzNgZFuvENDAZtH78zn_PGdeHKcXbHK-TzdHJ0YSVK_YaqEX2ODnLxf8d-qdyHa_XSiPM7hOg";
  const config = {
    headers: {
      'x-api-key':"gmedocumenthubtest.castrol.com",
      "Content-Type": "application/json",
      Authorizationtoken: `Bearer ${idToken}`,
    },
  };
  try {
    const resp = await axios.post(uploadDrn, formData, config);
    const { message } = resp.data;
    if (resp.statusText) return message;
    else throw message;
  } catch (ex) {
    console.log("Error occurred while saving DRN " + ex);
  }
};
export const uploadRecords = async (upData: any, token: any) => {
  const role = sessionStorage.getItem("role");
 
   upData.role = role;
  const config = {
    headers: {
      'x-api-key':"gmedocumenthubtest.castrol.com",
      "Content-Type": "application/json",
      Authorizationtoken: `Bearer ${token}`,
    },
  };
  try {
    let res = await axios.post(uploadDrn, upData, config);
    if (res.data.statusCode === 500) {
      return res.data.error
    }
    else if( res.status === 200 )return "upload success " + res.status;
  } catch (error) {
    return "Error occurred while saving DRN " + error;
  }
  // try {
  //   const res = await axios.get('http://localhost:3000/mock/region_res.json');
  //   if (res.data.statusCode === 500) {
  //     return res.data.error
  //   }
  //   else if( res.status === 200 )return "upload success " + res.status;
     
  // } catch (error) {
  //   return error
  // }
  
};
